import { fas } from "@fortawesome/free-solid-svg-icons";

export const FA_PREFIX = "fa:";

export const FA_ICONS: string[] = Array.from(
	new Set(Object.values(fas).filter(i => i && i.iconName).map(i => i.iconName))
).sort().map(name => FA_PREFIX + name);

export function isFaIcon(icon: string): boolean {
	return !!icon && icon.startsWith(FA_PREFIX);
}

export function faIconName(icon: string): string {
	return icon.slice(FA_PREFIX.length);
}
